/* eslint-disable import/prefer-default-export */
import { FontWeightSemiBold, Spacing12, Spacing8 } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';

export const BrandSpecificMenuItemStyling = css<{ selected: boolean }>`
    min-height: 32px;

    & > a {
        padding: ${Spacing8} ${Spacing12};
    }

    &:hover {
        font-weight: ${FontWeightSemiBold};
    }

    &:focus-within,
    &:active {
        background-color: transparent;
    }

    ${({ selected }) =>
        selected &&
        css`
            font-weight: ${FontWeightSemiBold};
            background-color: transparent;
            text-decoration: underline;
        `}
`;
